module.exports = __webpack_public_path__ + "img/about2.a69cc0bd.jpg";